<script lang="ts">
	import type { Snippet } from 'svelte';

	type Props = {
		children: Snippet;
		title: string;
		description: string;
		robots?: string;
	};
	let { children, title, description, robots = 'index, follow' }: Props = $props();
</script>

<svelte:head>
	<title>{title}</title>
	<meta name="description" content={description} />
	<meta name="robots" content={robots} />
</svelte:head>

<div class="mx-auto max-w-[1440px]">
	{#if children}
		{@render children()}
	{/if}
</div>
